module.exports = __webpack_public_path__ + "static/media/55_000009.f9d62659.jpg";